import { apiRequest } from '@/lib/api-client';
import {
  assertAnalyticsResponseScope,
  normalizeAnalyticsAddress
} from '@/lib/investor-analytics';
import {
  investorPnlQuerySchema,
  investorPnlResponseSchema,
  type InvestorPnlQuery,
  type InvestorPnlResponse
} from '../types/api';

export async function fetchInvestorPnl(
  address: string,
  chainId: number,
  params: InvestorPnlQuery = {},
  signal?: AbortSignal
): Promise<InvestorPnlResponse> {
  const investor = normalizeAnalyticsAddress(address);
  const query = investorPnlQuerySchema.parse(params);
  const response = await apiRequest(
    `/api/v1/investor/${encodeURIComponent(investor)}/pnl`,
    investorPnlResponseSchema,
    {
      auth: 'required',
      chainId,
      query,
      signal
    }
  );

  assertAnalyticsResponseScope(investor, chainId, response);
  return response;
}
